import ReactGA from "react-ga4";
import { isVendorUser } from "./AuthState";

export const ANALYTICS_MEASUREMENT_ID = "G-J5KX239711";

const KNOWN_TWO_SEGMENT_PATHS = new Set([
  "/collection/pdf",
  "/account/password",
]);

let initialized = false;

export function isAnalyticsEnabled() {
  if (process.env.REACT_APP_ENABLE_ANALYTICS === "false") {
    return false;
  }

  return process.env.NODE_ENV === "production";
}

const readStoredUser = () => {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) {
      return {};
    }

    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
};

export function isDesignerAnalyticsAudience(userInformation = readStoredUser()) {
  return !isVendorUser(userInformation);
}

export function designerPagePath(pathname, search = "") {
  if (!pathname) {
    return "/";
  }

  if (pathname === "/settings" || pathname.startsWith("/material/")) {
    return "";
  }

  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 2 && !KNOWN_TWO_SEGMENT_PATHS.has(pathname)) {
    return `/material/${segments[0]}/${segments[1]}`;
  }

  if (pathname === "/ext") {
    return search.includes("access=") ? "/ext?access=" : "/ext";
  }

  return pathname;
}

export function initAnalytics() {
  if (initialized || !isAnalyticsEnabled()) {
    return false;
  }

  try {
    ReactGA.initialize(ANALYTICS_MEASUREMENT_ID);
    initialized = true;
    return true;
  } catch {
    return false;
  }
}

export function trackPage(path) {
  if (!path || !isAnalyticsEnabled() || !isDesignerAnalyticsAudience()) {
    return;
  }

  try {
    ReactGA.send({ hitType: "pageview", page: path });
  } catch {
    // Never block the UI on analytics.
  }
}

export function trackEvent(name, params) {
  if (!name || !isAnalyticsEnabled() || !isDesignerAnalyticsAudience()) {
    return;
  }

  try {
    ReactGA.event(name, params);
  } catch {
    // Never block the UI on analytics.
  }
}
